import axios from 'axios'
import Qs from 'qs'
import Tool from '@/assets/js/utils.js'
import Bus from '@/assets/js/vueBus'
import $store from '@/store/common/index.js'
import { Message } from 'element-ui'

// import Vue from 'vue';
// window.utilVue = new Vue();

Tool.getSession()
// http request 拦截器

// 设置默认超时时间为15s， timeoutTips设置为true，会有请求超时的提示，默认不提示
axios.defaults.withCredentials = false
axios.defaults.timeout = 15000

// 用于连续多次点击时，取消之前的请求，之保留最后一次的请求状态
const pending = [] // 声明一个数组用于存储每个正在pending的状态请求
const { CancelToken } = axios
const removePending = (config, str) => {
  for (const i in pending) {
    if (pending[i].u === `${config.url}&${config.method}`) { // 当当前请求在数组中存在时执行函数体
      pending[i].f() // 执行取消操作
      pending.splice(i, 1)
    }
  }
}
let internetStatus = true // true => 代表在线  false => 代表离线

window.addEventListener('online', () => {
  internetStatus = true
})
window.addEventListener('offline', () => {
  internetStatus = false
})

axios.interceptors.request.use((config) => {
  if (!internetStatus) { // 代表离线 给提示
    // utilVue.$message('') //新实例化的vue实例
    Message({
      message: i18n.t('lang.internetOffline'),
      type: 'error'
    })
    return false
  }
  if (config.isCancelToken) {
    removePending(config, 'request') // 在一个axios发送前执行一下取消操作
    config.cancelToken = new CancelToken((cancel) => {
      // 这里的axios标识用请求地址&请求方式拼接的字符串
      pending.push({ u: `${config.url}&${config.method}`, f: cancel })
    })
  }

  if (!config.url.includes('/tvucc-token') && config.url.indexOf('/tvucc') > -1 || config.url.indexOf('/command') > -1 || config.url.indexOf('/tvucc-media') > -1) {
    if (config.method === 'post' && config.data.constructor !== FormData && config.headers['Content-Type'] != 'application/json;charset=UTF-8' && !config.contentType) {
      if (!config.url.includes('/tvucc-user/userDevice/existUserBindDevice')) {
        config.data = Qs.stringify(config.data)
      }
    }
    if (config.headers['Content-Type'] != 'application/json;charset=UTF-8') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    if (config.contentType) {
      config.headers['Content-Type'] = config.contentType
    }
  }
  // token page
  if (config.url.includes('/tvucc-token') || config.url.includes('/tvucc-user/userDevice/existUserBindDevice')) {
    config.headers['Content-Type'] = 'application/json'
  }
  const urlArr = ['/event/getEventById', '/event/addEvent', '/event/update', '/event/delete', '/event/listEventByTR']
  if (urlArr.includes(config.url)) {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = Qs.stringify(config.data)
  }
  if (config.requestBase && config.requestBase === 'GATEWAY') {
    const { protocol } = window.location
    const urlGateway = localStorage.getItem('cloudDriveGateWayUrl').split('//')[1]
    const url = `${protocol}//${urlGateway}/drive`
    config.baseURL = url
  }
  if (config.requestBase && config.requestBase === 'CloudDriver') { // https://cloud-drive-dev.tvunetworks.com/api/drive/available-regions/en
    const { protocol } = window.location
    const urlDriver = $store.state.baseUrl.cloudDriveUrl.split('//')[1]
    url = `${protocol}//${urlDriver}`
    config.baseURL = url
  }

  config.headers.Authorization = window.localStorage.getItem('channelSession')
  if (config.sessionRoleId && config.sessionRoleId != '') {
    config.headers.Authorization = config.sessionRoleId
  }
  //  添加gateway
  // 如果有的话给替换成gateway-dev.tvunetworks.com
  if (config.url.includes('/gatewayPlayoutUrl')) {
    const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
    const gatewayPlayoutUrl = `${window.location.protocol}//${urlInfo.gatewayPlayoutUrl}`
    config.url = config.url.replace('/gatewayPlayoutUrl', gatewayPlayoutUrl)
  }
  // console.log(config)
  try {
    const key = config.url.substr(config.url.lastIndexOf('/', config.url.lastIndexOf('/') - 1))
    const programId = window.Vue.prototype.$BehaviorSyns.getProgramId()
    if (window.Vue.prototype.$BehaviorSyns.InterfaceDictionary[key]) {
      if (programId) {
        if (config.data) {
          config.data.programId = programId
        } else {
          config.data = {
            programId
          }
        }
      }
    }
  } catch (err) {
    console.warn(err)
  }
  return config
}, (err) => Promise.reject(err)).time

axios.interceptors.response.use(
  (response) => {
    if (response.config && response.config.isCancelToken) {
      removePending(response.config, 'response') // 在一个axios响应后再执行一下取消操作，把已经完成的请求从pending中移除
    }
    try {
      window.Vue.prototype.$BehaviorSyns.JudgeOperationType(response.request.responseURL)
    } catch (err) {
      console.error(err)
    }
    if (response.data.errorCode === '81000001') {
      Bus.$emit('jumpLoginPage')
    }
    return response
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 406:
        case 402:
        case 401:
          sessionStorage.setItem('switchAccount', 'false')
          Bus.$emit('jumpLoginPage')
          break
          // 超时
        case 504:
          Message({
            message: i18n.t('lang.timeOut'),
            type: 'error'
          })
          break
        default: break
      }
      // 服务器异常处理
      if ((`${error.response.status}`).substr(0, 1) == '5' && error.response.status != 504) {
        Message({
          message: i18n.t('lang.serverFailed'),
          type: 'error'
        })
      }
    }
    if (error.message && error.message.includes('timeout')) {
      // timeoutTips设置为true，会有请求超时的提示，默认不提示
      if (error.config.timeoutTips) {
        Message({
          message: i18n.t('lang.timeOut'),
          type: 'error'
        })
      }
    }
    return Promise.reject(error.response)
  })
export default axios
